import { useMemo } from "react";
import { EXERCISE_LIBRARY, type LibraryExercise } from "../../data/exerciseLibrary";

export const MUSCLES = Array.from(new Set(EXERCISE_LIBRARY.map((e) => e.muscleGroup))).sort();

// Librería estática (ver data/exerciseLibrary.ts): filtrado instantáneo en cliente, sin red.
export function useExerciseCatalog(search: string, muscle: string | null) {
  const results = useMemo(() => {
    const q = search.trim().toLowerCase();
    return EXERCISE_LIBRARY.filter((e) => {
      if (muscle && e.muscleGroup !== muscle) return false;
      if (q && !e.name.toLowerCase().includes(q)) return false;
      return true;
    });
  }, [search, muscle]);

  return { results, loading: false as const };
}

export type { LibraryExercise };
